import BaseClient from '@/app/model/api/response/baseApiClient'

class MachineRentEditApi extends BaseClient {
  public doMachineRentEdit (id: string, bodyData: {[key:string]: any}) {
    const path:string = '/v1/machine-rents/' + id

    /* 共通処理 */
    return super.setBody(JSON.stringify(bodyData)).doFetch(process.env.VUE_APP_API_URL + path, 'PUT')
  }
}

export default new MachineRentEditApi()
